var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-column", staticStyle: { "padding-top": "10px" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.readonly,
              expression: "readonly"
            }
          ],
          staticStyle: { display: "flex" }
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.isEdit = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onLobChange } },
            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Refresh")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.lookConfig } },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("CargoMsg.Cargo_View") +
                    this.tabNumberTitle +
                    _vm.$t("CargoMsg.Cargo_Config")
                )
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEdit,
              expression: "isEdit"
            }
          ],
          staticStyle: { display: "flex" }
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.save } },
            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onLobChange } },
            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Refresh")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.reset } },
            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Reset")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.isEdit = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
          ),
          _vm.isMbl
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.serviceCode.visible = true
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("SystemMaintenance.ServiceCodeMaintenance"))
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticStyle: { "margin-top": "10px" },
          attrs: {
            "label-width": "90px",
            "label-position": "left",
            inline: true
          }
        },
        [
          _vm.showLob || _vm.showHblLob || _vm.showBill
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.BusinessType") } },
                [
                  _c(
                    "el-select",
                    {
                      on: { change: _vm.onLobChange },
                      model: {
                        value: _vm.lob,
                        callback: function($$v) {
                          _vm.lob = $$v
                        },
                        expression: "lob"
                      }
                    },
                    _vm._l(_vm.lobSource, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.showBill
            ? _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SystemMaintenance.BillOfLadingType") }
                },
                [
                  _c(
                    "el-select",
                    {
                      on: { change: _vm.onLobChange },
                      model: {
                        value: _vm.billType,
                        callback: function($$v) {
                          _vm.billType = $$v
                        },
                        expression: "billType"
                      }
                    },
                    _vm._l(_vm.billTypeSource, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-form",
        {
          staticStyle: { width: "700px" },
          attrs: { "label-width": "90px", "label-position": "left" }
        },
        [
          _vm.isMbl
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SystemMaintenance.RuleName") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "500px" },
                      on: { change: _vm.ruleChange },
                      model: {
                        value: _vm.ruleName,
                        callback: function($$v) {
                          _vm.ruleName = $$v
                        },
                        expression: "ruleName"
                      }
                    },
                    _vm._l(_vm.rules, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item }
                      })
                    }),
                    1
                  ),
                  !_vm.readonly
                    ? _c("span", [
                        _c("i", {
                          staticClass: "el-icon-circle-plus",
                          staticStyle: {
                            "font-size": "18px",
                            cursor: "pointer",
                            "margin-left": "5px",
                            color: "#1F75D5"
                          },
                          on: {
                            click: function($event) {
                              _vm.addRule.visible = true
                            }
                          }
                        }),
                        _vm.rules.length && _vm.details.name
                          ? _c("i", {
                              staticClass: "el-icon-delete",
                              staticStyle: {
                                "font-size": "18px",
                                cursor: "pointer",
                                "margin-left": "5px",
                                color: "#ff0000"
                              },
                              on: { click: _vm.removeRule }
                            })
                          : _vm._e()
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.isMbl
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SystemMaintenance.DesignatedShippingLine")
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "500px" },
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": { seaCmp: true, active: true },
                      "default-value": _vm.details.partnerId,
                      disabled: _vm.readonly,
                      filterable: ""
                    },
                    on: { parentCallBack: _vm.partnerIdChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SystemMaintenance.Expression") } },
            [
              _c("el-input", {
                staticStyle: { width: "500px" },
                attrs: { disabled: true },
                model: {
                  value: _vm.config.value,
                  callback: function($$v) {
                    _vm.$set(_vm.config, "value", $$v)
                  },
                  expression: "config.value"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SystemMaintenance.Example") } },
            [
              _c(
                "div",
                [
                  _c("el-input", {
                    staticStyle: { width: "500px" },
                    attrs: { disabled: true },
                    model: {
                      value: _vm.example,
                      callback: function($$v) {
                        _vm.example = $$v
                      },
                      expression: "example"
                    }
                  }),
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v("长度:" + _vm._s(_vm.example.length))
                  ])
                ],
                1
              )
            ]
          ),
          _c("el-form-item", { attrs: { "label-width": "0" } }, [
            _c("span", [_vm._v("请选择" + _vm._s(_vm.tabTitle) + "的组成元素")])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { margin: "0" }, attrs: { gutter: 10, type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly || _vm.tabName === "WriteOffNo"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _vm.showLob || _vm.showHblLob
                        ? _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("lob")
                                }
                              },
                              model: {
                                value: _vm.form.lob,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "lob", $$v)
                                },
                                expression: "form.lob"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.BusinessTypelob")
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _c("el-input", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.lob === "RI" || _vm.lob === "RE",
                            expression: "lob === 'RI' || lob === 'RE'"
                          }
                        ],
                        staticStyle: { float: "right", width: "60px" },
                        attrs: { id: "lob-val1", disabled: !_vm.form.lob },
                        on: {
                          change: function($event) {
                            return _vm.toPattern("lob")
                          }
                        },
                        model: {
                          value: _vm.form.val1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "val1", $$v)
                          },
                          expression: "form.val1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.showLob &&
                  (_vm.lob === "SE" ||
                    _vm.lob === "SI" ||
                    _vm.lob === "RE" ||
                    _vm.lob === "RI" ||
                    _vm.lob === "IE") &&
                  !_vm.isMbl
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("containerLoadType")
                                }
                              },
                              model: {
                                value: _vm.form.containerLoadType.checked,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.containerLoadType,
                                    "checked",
                                    $$v
                                  )
                                },
                                expression: "form.containerLoadType.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.lob === "IE"
                                    ? _vm.$t(
                                        "SeaExport.ComprehensiveLogisticsOrderType"
                                      )
                                    : _vm.$t("SeaExport.FLCLType")
                                )
                              )
                            ]
                          ),
                          _c("el-input", {
                            staticStyle: { float: "right", width: "60px" },
                            attrs: {
                              id: "containerLoadType-val2",
                              disabled: !_vm.form.containerLoadType.checked
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("containerLoadType")
                              }
                            },
                            model: {
                              value: _vm.form.containerLoadType.val2,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.containerLoadType,
                                  "val2",
                                  $$v
                                )
                              },
                              expression: "form.containerLoadType.val2"
                            }
                          }),
                          _c("el-input", {
                            staticStyle: {
                              float: "right",
                              width: "60px",
                              "margin-right": "10px"
                            },
                            attrs: {
                              id: "containerLoadType-val1",
                              disabled: !_vm.form.containerLoadType.checked
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("containerLoadType")
                              }
                            },
                            model: {
                              value: _vm.form.containerLoadType.val1,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.containerLoadType,
                                  "val1",
                                  $$v
                                )
                              },
                              expression: "form.containerLoadType.val1"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showLob && _vm.lob === "IE" && !_vm.isMbl
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("operateType")
                                }
                              },
                              model: {
                                value: _vm.form.operateType.checked,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.operateType, "checked", $$v)
                                },
                                expression: "form.operateType.checked"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.OperateType")))]
                          ),
                          _c("el-input", {
                            staticStyle: { float: "right", width: "60px" },
                            attrs: {
                              id: "operateType-val2",
                              disabled: !_vm.form.operateType.checked
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("operateType")
                              }
                            },
                            model: {
                              value: _vm.form.operateType.val2,
                              callback: function($$v) {
                                _vm.$set(_vm.form.operateType, "val2", $$v)
                              },
                              expression: "form.operateType.val2"
                            }
                          }),
                          _c("el-input", {
                            staticStyle: {
                              float: "right",
                              width: "60px",
                              "margin-right": "10px"
                            },
                            attrs: {
                              id: "operateType-val1",
                              disabled: !_vm.form.operateType.checked
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("operateType")
                              }
                            },
                            model: {
                              value: _vm.form.operateType.val1,
                              callback: function($$v) {
                                _vm.$set(_vm.form.operateType, "val1", $$v)
                              },
                              expression: "form.operateType.val1"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showLob && !_vm.isMbl
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("cargoSource")
                                }
                              },
                              model: {
                                value: _vm.form.cargoSource.checked,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.cargoSource, "checked", $$v)
                                },
                                expression: "form.cargoSource.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.CargoPickupType")
                                )
                              )
                            ]
                          ),
                          _c("el-input", {
                            staticStyle: { float: "right", width: "60px" },
                            attrs: {
                              id: "cargoSource-val2",
                              disabled: !_vm.form.cargoSource.checked
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("cargoSource")
                              }
                            },
                            model: {
                              value: _vm.form.cargoSource.val2,
                              callback: function($$v) {
                                _vm.$set(_vm.form.cargoSource, "val2", $$v)
                              },
                              expression: "form.cargoSource.val2"
                            }
                          }),
                          _c("el-input", {
                            staticStyle: {
                              float: "right",
                              width: "60px",
                              "margin-right": "10px"
                            },
                            attrs: {
                              id: "cargoSource-val1",
                              disabled: !_vm.form.cargoSource.checked
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("cargoSource")
                              }
                            },
                            model: {
                              value: _vm.form.cargoSource.val1,
                              callback: function($$v) {
                                _vm.$set(_vm.form.cargoSource, "val1", $$v)
                              },
                              expression: "form.cargoSource.val1"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showOffice
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("office")
                                }
                              },
                              model: {
                                value: _vm.form.office,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "office", $$v)
                                },
                                expression: "form.office"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.BranchCodeoffice")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showPartnerWarehouseCode
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.partnerWarehouseCodeChangeHandle()
                                }
                              },
                              model: {
                                value: _vm.form.partnerWarehouseCode.checked,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.partnerWarehouseCode,
                                    "checked",
                                    $$v
                                  )
                                },
                                expression: "form.partnerWarehouseCode.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.PartnerWarehouseCode"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.$t(
                                  "SystemMaintenance.PartnerWarehouseCodeTip"
                                )
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning",
                                staticStyle: {
                                  color: "#e6a23c",
                                  "margin-left": "5px"
                                }
                              })
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { float: "right" },
                              attrs: {
                                type: "primary",
                                disabled: !_vm.form.partnerWarehouseCode.checked
                              },
                              on: {
                                click: function($event) {
                                  _vm.warehouseCodePriorityDialog.visible = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ValueSetting"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showUserCode
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("userCode")
                                }
                              },
                              model: {
                                value: _vm.form.userCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "userCode", $$v)
                                },
                                expression: "form.userCode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.Salesperson"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showOp
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("opCode")
                                }
                              },
                              model: {
                                value: _vm.form.opCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "opCode", $$v)
                                },
                                expression: "form.opCode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.Operation"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showNetCode
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("netCode")
                                }
                              },
                              model: {
                                value: _vm.form.netCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "netCode", $$v)
                                },
                                expression: "form.netCode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.NetCodenetCode")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showDepart
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("salesDepart")
                                }
                              },
                              model: {
                                value: _vm.form.salesDepart,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "salesDepart", $$v)
                                },
                                expression: "form.salesDepart"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.SalesDepartment")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showDepart
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("opDepart")
                                }
                              },
                              model: {
                                value: _vm.form.opDepart,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "opDepart", $$v)
                                },
                                expression: "form.opDepart"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.OperationsDepartment"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showWarehouseCode && _vm.lob.startsWith("FBA")
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("warehouseCode")
                                }
                              },
                              model: {
                                value: _vm.form.warehouseCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "warehouseCode", $$v)
                                },
                                expression: "form.warehouseCode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.OverseasWarehouseCodeFBAFC"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showPort && !_vm.isWarehouse
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("basicPol")
                                }
                              },
                              model: {
                                value: _vm.form.basicPol,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "basicPol", $$v)
                                },
                                expression: "form.basicPol"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.PolCode"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showPort
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("port")
                                }
                              },
                              model: {
                                value: _vm.form.port,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "port", $$v)
                                },
                                expression: "form.port"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isWarehouse
                                    ? _vm.$t("SystemMaintenance.PortCodeport")
                                    : _vm.$t(
                                        "SystemMaintenance.DeliveryPlaceCodeport"
                                      )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showHblLob
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("pol")
                                }
                              },
                              model: {
                                value: _vm.form.pol,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "pol", $$v)
                                },
                                expression: "form.pol"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.DeparturePortCode")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showHblLob
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("pod")
                                }
                              },
                              model: {
                                value: _vm.form.pod,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "pod", $$v)
                                },
                                expression: "form.pod"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.DestinationPortCode"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMbl
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("polExCode")
                                }
                              },
                              model: {
                                value: _vm.form.polExCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "polExCode", $$v)
                                },
                                expression: "form.polExCode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.DeparturePortExchangeCode"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMbl
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("podExCode")
                                }
                              },
                              model: {
                                value: _vm.form.podExCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "podExCode", $$v)
                                },
                                expression: "form.podExCode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.DestinationPortExchangeCode"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isMbl
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("groupCode")
                                }
                              },
                              model: {
                                value: _vm.form.groupCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "groupCode", $$v)
                                },
                                expression: "form.groupCode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.ServiceCode"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showHblLob
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("sacaCode")
                                }
                              },
                              model: {
                                value: _vm.form.sacaCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "sacaCode", $$v)
                                },
                                expression: "form.sacaCode"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.OverseasAgentCode")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showJobNo
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("jobNo")
                                }
                              },
                              model: {
                                value: _vm.form.jobNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "jobNo", $$v)
                                },
                                expression: "form.jobNo"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.JobNumberjobNo")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showRp
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("rp")
                                }
                              },
                              model: {
                                value: _vm.form.rp,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "rp", $$v)
                                },
                                expression: "form.rp"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.ReceivableOrPayable"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showDate || _vm.showHblLob || _vm.showWarehouseNo
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("year")
                                }
                              },
                              model: {
                                value: _vm.form.year.checked,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.year, "checked", $$v)
                                },
                                expression: "form.year.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.showHblLob
                                    ? _vm.$t("SystemMaintenance.Jobyear")
                                    : _vm.$t("SystemMaintenance.Yearyear")
                                )
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { float: "right", width: "85px" },
                            attrs: {
                              disabled: !_vm.form.year.checked,
                              "controls-position": "right",
                              min: 1,
                              max: 4,
                              precision: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("year")
                              }
                            },
                            model: {
                              value: _vm.form.year.length,
                              callback: function($$v) {
                                _vm.$set(_vm.form.year, "length", $$v)
                              },
                              expression: "form.year.length"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Length")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showDate || _vm.showHblLob || _vm.showWarehouseNo
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("month")
                                }
                              },
                              model: {
                                value: _vm.form.month.checked,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.month, "checked", $$v)
                                },
                                expression: "form.month.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.showHblLob
                                    ? _vm.$t("SystemMaintenance.Jobmonth")
                                    : _vm.$t("SystemMaintenance.Monthmonth")
                                )
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { float: "right", width: "85px" },
                            attrs: {
                              disabled: !_vm.form.month.checked,
                              "controls-position": "right",
                              min: 1,
                              max: 2,
                              precision: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("month")
                              }
                            },
                            model: {
                              value: _vm.form.month.length,
                              callback: function($$v) {
                                _vm.$set(_vm.form.month, "length", $$v)
                              },
                              expression: "form.month.length"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Length")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showDate || _vm.showWarehouseNo
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("day")
                                }
                              },
                              model: {
                                value: _vm.form.day.checked,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.day, "checked", $$v)
                                },
                                expression: "form.day.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemMaintenance.Dateday"))
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { float: "right", width: "85px" },
                            attrs: {
                              disabled: !_vm.form.day.checked,
                              "controls-position": "right",
                              min: 1,
                              max: 2,
                              precision: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("day")
                              }
                            },
                            model: {
                              value: _vm.form.day.length,
                              callback: function($$v) {
                                _vm.$set(_vm.form.day, "length", $$v)
                              },
                              expression: "form.day.length"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Length")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tabName === "JobNo" ||
                  _vm.tabName === "MblNo" ||
                  _vm.tabName === "HblNo"
                    ? [
                        _vm.lob === "SE" || _vm.lob === "AE"
                          ? _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    on: {
                                      change: function($event) {
                                        return _vm.toPattern("etd")
                                      }
                                    },
                                    model: {
                                      value: _vm.form.etd,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "etd", $$v)
                                      },
                                      expression: "form.etd"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.DepartureDate"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.$t(
                                        "SystemMaintenance.YearMonthEtdTip"
                                      ),
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning",
                                      staticStyle: {
                                        padding: "0 5px",
                                        color: "#E6A23C",
                                        "font-size": "14px"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.lob === "SI" || _vm.lob === "AI"
                          ? _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    on: {
                                      change: function($event) {
                                        return _vm.toPattern("eta")
                                      }
                                    },
                                    model: {
                                      value: _vm.form.eta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "eta", $$v)
                                      },
                                      expression: "form.eta"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SystemMaintenance.ArrivalDate")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.$t(
                                        "SystemMaintenance.YearMonthEtaTip"
                                      ),
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning",
                                      staticStyle: {
                                        padding: "0 5px",
                                        color: "#E6A23C",
                                        "font-size": "14px"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.lob === "RI"
                          ? _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    on: {
                                      change: function($event) {
                                        return _vm.toPattern("eta")
                                      }
                                    },
                                    model: {
                                      value: _vm.form.eta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "eta", $$v)
                                      },
                                      expression: "form.eta"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("RailwayExport.ETA")))]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.$t(
                                        "SystemMaintenance.RiYearMonthEtaTip"
                                      ),
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning",
                                      staticStyle: {
                                        padding: "0 5px",
                                        color: "#E6A23C",
                                        "font-size": "14px"
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  ((_vm.tabName === "JobNo" &&
                    !["SE", "AE", "SI", "AI", "RI"].includes(_vm.lob)) ||
                    _vm.tabName !== "JobNo") &&
                  _vm.tabName !== "MblNo" &&
                  _vm.tabName !== "HblNo"
                    ? [
                        _vm.showLob && (_vm.lob === "SE" || _vm.lob === "AE")
                          ? _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    on: {
                                      change: function($event) {
                                        return _vm.toPattern("etd")
                                      }
                                    },
                                    model: {
                                      value: _vm.form.etd,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "etd", $$v)
                                      },
                                      expression: "form.etd"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.DepartureDate"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.lob === "RE" &&
                        ((_vm.showLob && _vm.showDepart) || _vm.showWarehouseNo)
                          ? _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    on: {
                                      change: function($event) {
                                        return _vm.toPattern("etd")
                                      }
                                    },
                                    model: {
                                      value: _vm.form.etd,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "etd", $$v)
                                      },
                                      expression: "form.etd"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SystemMaintenance.ShippingDate")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.lob === "RI"
                          ? _c(
                              "el-form-item",
                              [
                                _vm.showLob
                                  ? _c(
                                      "el-checkbox",
                                      {
                                        staticStyle: {
                                          "padding-right": "30px"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.toPattern("etd")
                                          }
                                        },
                                        model: {
                                          value: _vm.form.etd,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "etd", $$v)
                                          },
                                          expression: "form.etd"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.ShippingDate"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showLob && (_vm.lob === "SI" || _vm.lob === "AI")
                          ? _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    staticStyle: { "padding-right": "30px" },
                                    on: {
                                      change: function($event) {
                                        return _vm.toPattern("etd")
                                      }
                                    },
                                    model: {
                                      value: _vm.form.etd,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "etd", $$v)
                                      },
                                      expression: "form.etd"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.DepartureDate"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm.showJobSequence
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("jobSequence")
                                }
                              },
                              model: {
                                value: _vm.form.jobSequence.checked,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.jobSequence, "checked", $$v)
                                },
                                expression: "form.jobSequence.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.JobSequenceNumberjobSequence"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { float: "right", width: "85px" },
                            attrs: {
                              disabled: !_vm.form.jobSequence.checked,
                              "controls-position": "right",
                              min: 1,
                              max: 5,
                              precision: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("jobSequence")
                              }
                            },
                            model: {
                              value: _vm.form.jobSequence.length,
                              callback: function($$v) {
                                _vm.$set(_vm.form.jobSequence, "length", $$v)
                              },
                              expression: "form.jobSequence.length"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Length")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showRandomLetters
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("randomLetter")
                                }
                              },
                              model: {
                                value: _vm.form.randomLetter.checked,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.randomLetter,
                                    "checked",
                                    $$v
                                  )
                                },
                                expression: "form.randomLetter.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.RandomLetters")
                                )
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { float: "right", width: "85px" },
                            attrs: {
                              disabled: !_vm.form.randomLetter.checked,
                              "controls-position": "right",
                              min: 1,
                              max: 4,
                              precision: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("randomLetter")
                              }
                            },
                            model: {
                              value: _vm.form.randomLetter.length,
                              callback: function($$v) {
                                _vm.$set(_vm.form.randomLetter, "length", $$v)
                              },
                              expression: "form.randomLetter.length"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Length")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showSequence
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("sequence")
                                }
                              },
                              model: {
                                value: _vm.form.sequence.checked,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.sequence, "checked", $$v)
                                },
                                expression: "form.sequence.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.SequenceNumbersequence"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { float: "right", width: "85px" },
                            attrs: {
                              disabled: !_vm.form.sequence.checked,
                              "controls-position": "right",
                              min: 1,
                              max: 9,
                              precision: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("sequence")
                              }
                            },
                            model: {
                              value: _vm.form.sequence.length,
                              callback: function($$v) {
                                _vm.$set(_vm.form.sequence, "length", $$v)
                              },
                              expression: "form.sequence.length"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Length")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showCustomJobType
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("customJobType")
                                }
                              },
                              model: {
                                value: _vm.form.customJobType.checked,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.customJobType,
                                    "checked",
                                    $$v
                                  )
                                },
                                expression: "form.customJobType.checked"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.CustomBusinessTypecustomJobType"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("el-input-number", {
                            staticStyle: { float: "right", width: "85px" },
                            attrs: {
                              disabled: !_vm.form.customJobType.checked,
                              "controls-position": "right",
                              min: 1,
                              max: 4,
                              precision: 0
                            },
                            on: {
                              change: function($event) {
                                return _vm.toPattern("customJobType")
                              }
                            },
                            model: {
                              value: _vm.form.customJobType.length,
                              callback: function($$v) {
                                _vm.$set(_vm.form.customJobType, "length", $$v)
                              },
                              expression: "form.customJobType.length"
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "10px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Length")))]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              ),
              _c(
                "el-card",
                { staticClass: "box-card" },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SystemMaintenance.SequenceNumberSettings")
                        )
                      )
                    ])
                  ]),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly || !_vm.form.sequence.checked
                      }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.tabName === "WriteOffNo" },
                          on: {
                            change: function($event) {
                              return _vm.toPattern("sequence")
                            }
                          },
                          model: {
                            value: _vm.form.sequence.set,
                            callback: function($$v) {
                              _vm.$set(_vm.form.sequence, "set", $$v)
                            },
                            expression: "form.sequence.set"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            { staticStyle: { height: "30px" } },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { float: "left" },
                                  attrs: { label: "N" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemMaintenance.NeverResetN")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { float: "left" },
                                  attrs: { label: "Y" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemMaintenance.ResetByYearY")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticStyle: { height: "30px" } },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { float: "left" },
                                  attrs: { label: "M" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemMaintenance.ResetByMonthM")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { float: "left" },
                                  attrs: { label: "D" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemMaintenance.ResetByDayD")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.showLob && _vm.lob === "IE"
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.toPattern("businessDate")
                                    }
                                  },
                                  model: {
                                    value: _vm.form.businessDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "businessDate", $$v)
                                    },
                                    expression: "form.businessDate"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SystemMaintenance.BusinessDate")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      ((_vm.tabName === "JobNo" &&
                        !["SE", "AE", "SI", "AI", "RI"].includes(_vm.lob)) ||
                        _vm.tabName !== "JobNo") &&
                      _vm.tabName !== "MblNo" &&
                      _vm.tabName !== "HblNo"
                        ? [
                            _vm.lob === "RI" &&
                            ((_vm.showLob && _vm.showDepart) ||
                              _vm.showWarehouseNo)
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        on: {
                                          change: function($event) {
                                            return _vm.toPattern("eta")
                                          }
                                        },
                                        model: {
                                          value: _vm.form.eta,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "eta", $$v)
                                          },
                                          expression: "form.eta"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("RailwayExport.ETA"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.showLob &&
                            (_vm.lob === "SI" || _vm.lob === "AI")
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        on: {
                                          change: function($event) {
                                            return _vm.toPattern("eta")
                                          }
                                        },
                                        model: {
                                          value: _vm.form.eta,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "eta", $$v)
                                          },
                                          expression: "form.eta"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "SystemMaintenance.ArrivalDate"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { disabled: _vm.tabName === "WriteOffNo" } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { disabled: _vm.tabName === "WriteOffNo" },
                              on: {
                                change: function($event) {
                                  return _vm.toPattern("sequence")
                                }
                              },
                              model: {
                                value: _vm.form.sequence.O,
                                callback: function($$v) {
                                  _vm.$set(_vm.form.sequence, "O", $$v)
                                },
                                expression: "form.sequence.O"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SystemMaintenance.BranchSequenceNumberIndependent"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.showCustomJobType
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.toPattern("sequence")
                                    }
                                  },
                                  model: {
                                    value: _vm.form.sequence.C,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form.sequence, "C", $$v)
                                    },
                                    expression: "form.sequence.C"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SystemMaintenance.CustomJobTypeSequenceNumberIndependent"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showIo
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: function(p) {
                                      _vm.changeIo(_vm.form.sequence.F)
                                      _vm.toPattern("sequence")
                                    }
                                  },
                                  model: {
                                    value: _vm.form.sequence.F,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form.sequence, "F", $$v)
                                    },
                                    expression: "form.sequence.F"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SystemMaintenance.PaymentDirectionSerialNo"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showBillDate
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.toPattern("billDate")
                                    }
                                  },
                                  model: {
                                    value: _vm.form.billDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "billDate", $$v)
                                    },
                                    expression: "form.billDate"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      this.tabName === "BillingInternalNo" ||
                                        this.tabName === "BillingNo"
                                        ? _vm.$t(
                                            "SystemMaintenance.TakeBillDateOnYearMonthDay"
                                          )
                                        : _vm.$t(
                                            "SystemMaintenance.TakeDocumentDateOnYearMonthDay"
                                          )
                                    )
                                  )
                                ]
                              ),
                              _c("el-tooltip", [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: {
                                    color: "#f4973a",
                                    cursor: "pointer",
                                    "margin-left": "20px",
                                    "margin-right": "2px"
                                  }
                                }),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.UseBillDateOnYearMonthDay"
                                    )
                                  ) + " "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.showPayDate
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "el-checkbox",
                                {
                                  on: {
                                    change: function($event) {
                                      return _vm.toPattern("payDate")
                                    }
                                  },
                                  model: {
                                    value: _vm.form.payDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "payDate", $$v)
                                    },
                                    expression: "form.payDate"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SystemMaintenance.TakeActualPayDateOnYearMonthDay"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("el-tooltip", [
                                _c("i", {
                                  staticClass: "el-icon-warning",
                                  staticStyle: {
                                    color: "#f4973a",
                                    cursor: "pointer",
                                    "margin-left": "20px",
                                    "margin-right": "2px"
                                  }
                                }),
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.UseActualPayDateOnYearMonthDay"
                                    )
                                  ) + " "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm.showIo
                ? _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.readonly || _vm.form.sequence.F },
                      on: {
                        change: function($event) {
                          return _vm.toPattern("io")
                        }
                      },
                      model: {
                        value: _vm.form.io,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "io", $$v)
                        },
                        expression: "form.io"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SystemMaintenance.ReceivableAndPayableio")
                        )
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticStyle: { display: "flex", "flex-direction": "column" },
              attrs: { span: 8 }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: {
                    disabled: _vm.readonly || _vm.tabName === "WriteOffNo"
                  },
                  model: {
                    value: _vm.config.overrideable,
                    callback: function($$v) {
                      _vm.$set(_vm.config, "overrideable", $$v)
                    },
                    expression: "config.overrideable"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("SystemMaintenance.BranchConfigurationIndependent")
                    )
                  )
                ]
              ),
              _c(
                "div",
                { staticStyle: { display: "flex", "flex-grow": "1" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-grow": "1",
                        "flex-direction": "column"
                      }
                    },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "table",
                          class: _vm.readonly ? "not-click" : "",
                          staticStyle: { "flex-grow": "1" },
                          attrs: {
                            data: _vm.expressList,
                            "show-header": false,
                            border: "",
                            "highlight-current-row": ""
                          },
                          on: { "current-change": _vm.handleCurrentChange }
                        },
                        [
                          _c("el-table-column", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "div",
                                      {
                                        class: row.isConstant
                                          ? "row-constant"
                                          : "",
                                        staticStyle: { padding: "0 3px 0 5px" }
                                      },
                                      [
                                        _vm.showHblLob
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("filterName")(row.name)
                                                )
                                              )
                                            ])
                                          : _c("span", [
                                              _vm._v(_vm._s(row.name))
                                            ]),
                                        row.isConstant
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: { float: "right" }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-edit edit-btn",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.showConstantDialog(
                                                        row
                                                      )
                                                    }
                                                  }
                                                }),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-delete delete-btn",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.deleteConstant(
                                                        row.sequence
                                                      )
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm.isMbl
                        ? _c(
                            "el-card",
                            {
                              staticClass: "box-card",
                              staticStyle: { "margin-top": "5px" }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "header" }, slot: "header" },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SystemMaintenance.JoiningDeclarationNumberRule"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "el-form",
                                {
                                  attrs: { inline: "", disabled: _vm.readonly }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          label: _vm.$t(
                                            "SystemMaintenance.LetterSuffix"
                                          )
                                        },
                                        model: {
                                          value: _vm.details.childNoLetter,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.details,
                                              "childNoLetter",
                                              $$v
                                            )
                                          },
                                          expression: "details.childNoLetter"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          label: _vm.$t(
                                            "SystemMaintenance.LetterexcludingIAndO"
                                          )
                                        },
                                        model: {
                                          value:
                                            _vm.details.childNoLetterFriendly,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.details,
                                              "childNoLetterFriendly",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "details.childNoLetterFriendly"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          label: _vm.$t(
                                            "SystemMaintenance.NumberSuffix"
                                          )
                                        },
                                        model: {
                                          value: _vm.details.childNoNumber,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.details,
                                              "childNoNumber",
                                              $$v
                                            )
                                          },
                                          expression: "details.childNoNumber"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          label: _vm.$t(
                                            "SystemMaintenance.MasterBillExtension"
                                          )
                                        },
                                        model: {
                                          value: _vm.details.childNoExtension,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.details,
                                              "childNoExtension",
                                              $$v
                                            )
                                          },
                                          expression: "details.childNoExtension"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "SystemMaintenance.SuffixSeparator"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          model: {
                                            value: _vm.details.childNoSplit,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.details,
                                                "childNoSplit",
                                                $$v
                                              )
                                            },
                                            expression: "details.childNoSplit"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "SystemMaintenance.None"
                                              ),
                                              value: ""
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: { label: "-", value: "-" }
                                          }),
                                          _c("el-option", {
                                            attrs: { label: "*", value: "*" }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-column" },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "margin-left": "5px",
                            "margin-bottom": "5px"
                          },
                          attrs: {
                            type: "primary",
                            disabled:
                              _vm.readonly || _vm.tabName === "WriteOffNo"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showConstantDialog()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.AddConstant"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "margin-left": "5px",
                            "margin-bottom": "5px"
                          },
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.currentExpress ||
                              _vm.tabName === "WriteOffNo",
                            type: "primary"
                          },
                          on: { click: _vm.moveUp }
                        },
                        [_vm._v("↑")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.readonly ||
                              !_vm.currentExpress ||
                              _vm.tabName === "WriteOffNo",
                            type: "primary"
                          },
                          on: { click: _vm.moveDown }
                        },
                        [_vm._v("↓")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "inner-row", staticStyle: { color: "red" } }, [
        _vm._v(_vm._s(_vm.remark))
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.constantDialog.visible,
            title: _vm.constantDialog.title,
            width: "300px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.constantDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "inner-row" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "40px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Constant") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.constantDialog.express.text,
                          callback: function($$v) {
                            _vm.$set(_vm.constantDialog.express, "text", $$v)
                          },
                          expression: "constantDialog.express.text"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.saveConstant()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.constantDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.isMbl
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.$t("SystemMaintenance.AddRule"),
                visible: _vm.addRule.visible,
                width: "400px"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-position": "top" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SystemMaintenance.PleaseEnterRuleName")
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.addRule.name,
                          callback: function($$v) {
                            _vm.$set(_vm.addRule, "name", $$v)
                          },
                          expression: "addRule.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleAddRule }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.addRule.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isMbl
        ? _c("service-code-dialog", {
            attrs: { visible: _vm.serviceCode.visible },
            on: {
              close: function($event) {
                _vm.serviceCode.visible = false
              }
            }
          })
        : _vm._e(),
      _c("warehouse-code-priority-dialog", {
        attrs: {
          visible: _vm.warehouseCodePriorityDialog.visible,
          "val-list": _vm.form.partnerWarehouseCode.valList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseCodePriorityDialog, "visible", $event)
          },
          confirm: function($event) {
            return _vm.warehouseCodePriorityConfirmHandle($event)
          }
        }
      }),
      _vm.lookConfigDialog.visible
        ? _c("number-config-search-dialog", {
            ref: "numberConfigSearchDialog",
            attrs: {
              "tab-name": _vm.tabName,
              "tab-number-title": _vm.tabNumberTitle,
              visible: _vm.lookConfigDialog.visible
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.lookConfigDialog, "visible", $event)
              },
              query: _vm.queryHandle
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }